import axios from "axios";
import {setupAxiosInterceptors} from "./AxiosConfigService";

// Registration request for new user
const register = async (username, password, firstName, lastName) => {
  const response = await axios({
    url: process.env.REACT_APP_BO_REGISTER_URL,
    method: "POST",
    data: {
      username: username,
      password: password,
      firstName: firstName,
      lastName: lastName,
    },
  });

  return { ...response };
};

// Login request
const login = async (username, password) => {
  const response = await axios({
    url: process.env.REACT_APP_BO_LOGIN_URL,
    method: "POST",
    data: {
      username: username,
      password: password,
    },
  });

  const authHeader = response.headers["authorization"];
  const token = authHeader.replace("Bearer ", "");

  // Set the token for subsequent requests and persist interceptor id if provided
  const interceptorId = setupAxiosInterceptors(token);
  try {
    // store interceptor id so we can remove it on logout
    if (interceptorId !== undefined && interceptorId !== null) {
      localStorage.setItem("TokenInterceptor", String(interceptorId));
    }
  } catch (e) {
    /* ignore storage errors */
  }

  return token;
};

// Logs out
const logout = () => {
  // Attempt to remove the stored interceptor if one was saved
  try {
    const idStr = localStorage.getItem("TokenInterceptor");
    if (idStr) {
      const id = parseInt(idStr, 10);
      if (!isNaN(id)) {
        axios.interceptors.request.eject(id);
      }
    }
  } catch (e) {
    /* ignore eject errors */
  }

  // Remove any default Authorization header just in case
  try {
    delete axios.defaults.headers.common["Authorization"];
  } catch (e) {
    /* ignore */
  }

  try {
    localStorage.removeItem("TokenInterceptor");
  } catch (e) {
    /* ignore */
  }
};

// --- new: on module load, if there is a persisted auth token re-install interceptor ---
try {
  const raw = sessionStorage.getItem("backOfficeAuthState");
  if (raw) {
    const parsed = JSON.parse(raw);
    const token = parsed && parsed.token;
    if (token) {
      // Re-install axios interceptor so Authorization header is sent after refresh
      const interceptorId = setupAxiosInterceptors(token);
      if (interceptorId !== undefined && interceptorId !== null) {
        try {
          localStorage.setItem("TokenInterceptor", String(interceptorId));
        } catch (e) {
          /* ignore */
        }
      }
    }
  }
} catch (e) {
  /* ignore parse/storage errors */
}

const backofficeService = {
  register,
  login,
  logout,
};
export default backofficeService;
